import React from 'react';
import * as FaIcons from 'react-icons/fa';
import * as Fa6Icons from 'react-icons/fa6';
import SafeIcon from './common/SafeIcon';

const { FaFacebookF, FaInstagram } = FaIcons;
const { FaThreads } = Fa6Icons;

const contactLinks = [
  {
    label: 'Threads',
    href: 'https://www.threads.com/@homy.hk',
    icon: FaThreads
  },
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/homy.hk',
    icon: FaInstagram
  },
  {
    label: 'Facebook',
    href: 'https://www.facebook.com/profile.php?id=61578745554661',
    icon: FaFacebookF
  }
];

export default function ContactLinks() {
  return (
    <nav className="flex shrink-0 items-center gap-2" aria-label="Homy Tech 聯絡方式">
      {contactLinks.map(({ label, href, icon }) => (
        <a
          key={label}
          href={href}
          target="_blank"
          rel="me noopener noreferrer"
          className="text-white/45 transition-colors hover:text-cyan-400"
          aria-label={`透過 ${label} 聯絡 Homy Tech`}
          title={`透過 ${label} 聯絡 Homy Tech`}
        >
          <SafeIcon
            icon={icon}
            className="h-3.5 w-3.5 md:h-4 md:w-4"
          />
        </a>
      ))}
    </nav>
  );
}